import React from "react";
import { UserStatsMontagem } from "../types";
import { RankingItem } from "./RankingItem";
import { EmptyState } from "./EmptyState";

interface RankingListProps {
  montadores: UserStatsMontagem[];
  maxItems?: number;
}

export const RankingList: React.FC<RankingListProps> = ({
  montadores,
  maxItems = 12,
}) => {
  if (montadores.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="flex-1 space-y-1.5 overflow-y-auto sm:space-y-2">
      {montadores.slice(0, maxItems).map((montador, index) => (
        <RankingItem
          key={`${montador.nome}-${montador.sobrenome}-${index}`}
          montador={montador}
          index={index}
        />
      ))}
    </div>
  );
};
